















































import { Component, Vue } from "vue-property-decorator";
import BaseOverview, { Loadable } from "@/resources/components/BaseOverview.vue";
import Division from "@/app/models/Division";
import Station from "@/app/models/Station";
import debounce from "lodash/debounce";

@Component({
    components: {
        "base-overview": BaseOverview,
    },
})
export default class Index extends Vue {
    searchString: string = "";
    $refs!: {
        overview: BaseOverview
    };
    search = debounce(() => this.$refs.overview.reset(), 250);
    division: Division|null = null;

    destroy() {
        if (confirm(this.$t('Weet u zeker dat u deze afdeling wilt verwijderen?') as string)) {
            this.task(async () => await this.division!.destroy())
                .then(() => this.$router.replace({ name: 'divisions.index' }));
        }
    }

    async mounted() {
        this.division = await Division.show(parseInt(this.$route.params.division)) as Division
    }

    async loadItems(loadable: Loadable) {
        loadable.loadItems(
            (await Station.index(loadable.page, {
                search  : this.searchString,
                division: this.$route.params.division,
            })).data
        );
    }
}
